export default __webpack_public_path__ + "static/media/image-board-study-ranking-n-w@3x.28cfb21d.png";